<section class="bk-panel rg" aria-labelledby="rg-group-title">
  <header class="rg__head">
    <h2 class="bk-eyebrow" id="rg-group-title">Delivery by group</h2>
    <span class="rg__note">Share of each group's messages delivered</span>
  </header>

  @if (groups.length) {
    <div class="rg__canvas" [style.height.px]="height" role="img" [attr.aria-label]="'Delivery rate for ' + groups.length + ' groups'">
      <canvas baseChart [type]="'bar'" [data]="chartData" [options]="chartOptions"></canvas>
    </div>

    <!-- The same figures as text, for screen readers and exact values -->
    <table class="bk-sr-only">
      <caption>Delivery rate by group</caption>
      <tr><th scope="col">Group</th><th scope="col">Delivered</th></tr>
      @for (group of groups; track $index) {
        <tr><td>{{ group.groupName }}</td><td>{{ group.deliveryRate }}%</td></tr>
      }
    </table>
  } @else {
    <p class="rg__empty">No delivery data by group yet. It appears once receipts come back for a send.</p>
  }
</section>
